var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeTatUpper = function SvgEyeTatUpper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 43,
    height: 34,
    viewBox: "0 0 1 0.77",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2314198831504"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.92.57C.96.56.85.48.81.46.54.31.42.41.2.58.42.76.63.76.92.57zM.06.36C.07.35.07.29.07.26.08.24.09.23.09.2c0-.01.02.01.03.01.04.02.05.03.1.04.01 0 .01.01.02.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.07.29C.11.28.16.24.19.23M.45.08C.44.11.44.21.49.22.57.25.65.17.47.14.41.13.57.15.52.08.5.05.45.05.42.06M.9.14C.84.14.78.16.8.23.81.3.89.34.94.32"
  })))));
};

export default SvgEyeTatUpper;